import React, { useState, useEffect } from 'react';
import { Quotes } from '@phosphor-icons/react';
import { motion } from '@/lib/motion';
import axios from 'axios';

const clientNames = ['MARRIOTT', 'HILTON', 'EMAAR', 'DAMAC', 'NAKHEEL', 'MERAAS', 'ALDAR', 'SOBHA'];

export function ClientLogos() {
  return (
    <section className="py-10 md:py-12 bg-white border-y border-black/5" data-testid="client-logos-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <p className="label-architectural text-concrete/50 text-center mb-6 text-[10px]">
          TRUSTED BY LEADING DEVELOPERS
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {clientNames.map((name, i) => (
            <motion.span 
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="font-display text-xs md:text-sm font-bold text-obsidian/20 tracking-wider"
            >
              {name}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}

const defaultTestimonials = [
  {
    quote: "IHGIND UNDERSTANDS HOW ARCHITECTS THINK. THEY CONTRIBUTE TO THE DESIGN PROCESS.",
    client_name: "SENIOR ASSOCIATE",
    company: "INTERNATIONAL ARCHITECTURE FIRM"
  },
  {
    quote: "THE LEVEL OF FINISH QUALITY IS EXCEPTIONAL. THEY UNDERSTAND LUXURY INTERIORS.",
    client_name: "PRINCIPAL DESIGNER", 
    company: "DUBAI INTERIOR STUDIO"
  },
  {
    quote: "IHGIND DELIVERS WHAT THEY PROMISE. NO SURPRISES, NO DELAYS.",
    client_name: "PROJECT DIRECTOR",
    company: "MAJOR REGIONAL CONTRACTOR"
  },
];

const API = process.env.REACT_APP_BACKEND_URL;

export function Testimonials() {
  const [testimonials, setTestimonials] = useState(defaultTestimonials);

  useEffect(() => {
    axios.get(`${API}/api/testimonials`).then(res => {
      if (Array.isArray(res.data) && res.data.length > 0) {
        setTestimonials(res.data);
      }
    }).catch(() => {});
  }, []);

  return (
    <section className="py-12 md:py-16 bg-obsidian" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-10">
          <span className="label-architectural text-bronze/60">TESTIMONIALS</span>
          <h2 className="font-display text-xl md:text-2xl font-bold text-white mt-2">
            WHAT OUR PARTNERS SAY
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((item, i) => (
            <motion.div 
              key={item.id || i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="p-6 border border-white/20 bg-white/5"
              data-testid={`testimonial-${i}`}
            >
              <Quotes weight="fill" className="w-6 h-6 text-bronze mb-4" />
              <p className="font-body text-sm text-white mb-6 leading-relaxed">
                "{item.quote}"
              </p>
              <div className="pt-4 border-t border-white/20">
                <p className="font-display text-xs font-bold text-white">{item.client_name || item.author}</p>
                <p className="font-body text-[10px] text-white/60">{item.company}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
